<div class="modal">
  <div class="close-button" aria-label="close" [mat-dialog-close]="">
    <svg viewBox="0 0 10 11" width="10" height="11" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" fill="#666" clip-rule="evenodd" d="M5.94275 5.50033L9.47142 1.97166C9.73209 1.711 9.73209 1.28966 9.47142 1.029C9.21075 0.768329 8.78942 0.768329 8.52875 1.029L5.00008 4.55766L1.47142 1.029C1.21075 0.768329 0.789419 0.768329 0.528752 1.029C0.268085 1.28966 0.268085 1.711 0.528752 1.97166L4.05742 5.50033L0.528752 9.029C0.268085 9.28966 0.268085 9.711 0.528752 9.97166C0.658752 10.1017 0.829418 10.167 1.00009 10.167C1.17075 10.167 1.34142 10.1017 1.47142 9.97166L5.00008 6.443L8.52875 9.97166C8.65875 10.1017 8.82942 10.167 9.00008 10.167C9.17075 10.167 9.34142 10.1017 9.47142 9.97166C9.73209 9.711 9.73209 9.28966 9.47142 9.029L5.94275 5.50033Z"/></svg>
  </div>

  <div class="qr-image">
    <img [src]="data.png" alt="" />
  </div>

  <div class="actions-wrapper actions-wrapper--popup modal__button-wrapper">
    <a [href]="data.png" download target="_blank">
      <btn
        [wide]="true"
        mat-dialog-close="download"
        buttonText="ref-links.qr-modal.download"
      ></btn>
    </a>

    <a [href]="data.pdf" download target="_blank">
      <btn
        [link]="true"
        mat-dialog-close="download"
        buttonText="ref-links.qr-modal.pdf"
      ></btn>
    </a>
  </div>
</div>
